import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const SolutionSection = () => {
  return <section className="py-20 px-6 md:px-12 bg-gradient-to-b from-white to-teal-50" data-id="element-259">
      <div className="max-w-6xl mx-auto" data-id="element-260">
        <div className="text-center mb-16" data-id="element-261">
          <span className="bg-teal-100 text-teal-800 px-4 py-1 rounded-full text-sm font-semibold inline-block mb-4" data-id="element-262">
            THE SOLUTION
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-teal-900 mb-8 leading-tight" data-id="element-263">
            What If You Could Give Every Client These Tools—
            <span className="bg-gradient-to-r from-teal-600 to-teal-800 bg-clip-text text-transparent" data-id="element-264">
              Without Building Them All Yourself?
            </span>
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-265">
            <p className="text-xl md:text-2xl text-teal-800 font-medium mb-6" data-id="element-266">
              With the Neurotoned Professional Access Pass, you can.
            </p>
            <div className="h-1 w-24 bg-teal-600 mx-auto rounded-full mb-8" data-id="element-267"></div>
          </div>
        </div>
        
      </div>
    </section>;
};
export default SolutionSection;